import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#6cf0ff' },
    secondary: { main: '#ff6b97' },
    background: {
      default: '#0b1021',
      paper: 'rgba(22, 29, 51, 0.7)',
    },
    text: {
      primary: '#e9ecf5',
      secondary: '#9fb4d3',
    },
    success: { main: '#5efc9a' },
    warning: { main: '#ffc857' },
    error: { main: '#ff6b6b' },
  },
  shape: { borderRadius: 14 },
  typography: {
    fontFamily: "'Urbanist', 'Inter', 'SF Pro Display', 'Roboto', sans-serif",
    h4: { letterSpacing: '0.01em', fontWeight: 700 },
    h6: { letterSpacing: '0.02em', fontWeight: 600 },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  shadows: [
    'none',
    '0 10px 40px rgba(0,0,0,0.35)',
    '0 18px 60px rgba(0,0,0,0.45)',
    ...Array(22).fill('0 18px 60px rgba(0,0,0,0.45)'),
  ],
});

